
import useAppState from '../../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { calculOffers, calculOffersRetired, isPropositionInDraft } from '../../utils/dataUtils';
import useFetchGaranties from '../../hooks/useFetchGaranties';
import LoaderModal from '../../modals/common/LoaderModal';
import MgpMessage from '../../elements/MgpMessage/MgpMessage';
import { mapCoverageType, getPriceOfOffer, getPriceOfOption } from '../../utils/utils';
import { useEffect, useState } from 'react';
import { garanteeType, IPerson, IOffersDetails, IOptionCotisation, IRERequestDataOffers, ISimulateOffers, regimeType, relationType, simulationProcessType } from '../../context/model';
import { APP_URLS } from '../../const/AppConst';

interface RecapGuarantyFormComponentProps {
    modifyUrl: string
}


export default function RecapGuarantyFormComponent({modifyUrl} : Readonly<RecapGuarantyFormComponentProps>) {
    const {loading, garanties} = useFetchGaranties();
    const {
        state: { proposition, updatedProposition, jwtToken, additionalData },
        
    } = useAppState();

    const navigate = useNavigate();

    const [offers, setOffers] = useState<IOptionCotisation[]>([]);
    const [options, setOptions] = useState<Record<string, IOffersDetails | null>>({});
    const guarantyCode = garanties.find(e => e.code === updatedProposition!.offerCode);
    const offerPrice = guarantyCode ? getPriceOfOffer(offers, guarantyCode.code) : "0 €";
    const optionPrice = guarantyCode ? getPriceOfOption(options, guarantyCode?.code) : "0 €";

    const arrChildren = updatedProposition?.beneficiaries?.filter(el => el.relationType === relationType.CHILD);
    let resultChildren = [] as IPerson[];
    arrChildren?.forEach((child) => {
        resultChildren.push({
            birthDate: child.contact.birthDate,
            regimeType: child.contact.alsaceMoselleRegime ? regimeType.ALSACE_MOSELLE : regimeType.GENERAL
        });
    });
        
    const effectiveDateStr = proposition?.effectiveDate ? new Date(proposition.effectiveDate).toISOString().split('T')[0] : null;
    const resultPartner =  updatedProposition?.beneficiaries?.find(el => el.relationType !== relationType.CHILD);

    useEffect(() => {
          const fetchTotal = async () => {
            if (jwtToken) {
              const token = jwtToken.accessToken;
              if (modifyUrl === APP_URLS.guarantyPage) {
                const body = {
                  garanteeType : garanteeType.MIOM_BASE,
                  coverageType: mapCoverageType(guarantyCode?.code as string),
                  effectiveDate: effectiveDateStr,
                  hasPartner: !!resultPartner,
                  partner: resultPartner ? {
                    birthDate: resultPartner?.contact.birthDate,
                    regimeType: resultPartner?.contact.alsaceMoselleRegime ? regimeType.ALSACE_MOSELLE : regimeType.GENERAL
                  } as IPerson : null,
                  hasChild: arrChildren!.length > 0,
                  children: resultChildren,
                  regimeType: updatedProposition?.alsaceMoselleRegime ? regimeType.ALSACE_MOSELLE : regimeType.GENERAL,
                  simulationProcessType: simulationProcessType.SIMULATION,
                  salaryAmount: 0
                } as ISimulateOffers;
                const result = await calculOffers(token, body);   
        
                setOptions(opt => ({
                  ...opt,
                  [guarantyCode?.code as string]: result
                }));
                
              } else {
                const body = {
                    principalMemberInfo: {
                      retiredDate: updatedProposition?.retirementDate,
                      birthDate: updatedProposition?.birthDate,
                      hasAlsaceMoselle: updatedProposition?.alsaceMoselleRegime
                    },
                    partnerInfo: additionalData?.hasPartner ? additionalData?.partnerInfo : null,
                    childrenInfo: additionalData?.children,
                    effectiveDate: updatedProposition?.effectiveDate,
                    coveragesInfo:updatedProposition?.coveragesInfo
                  } as IRERequestDataOffers;
                  const result = await calculOffersRetired(token, body);
                  setOffers(result);
              }
            }
          } 
      
          fetchTotal();
    }, []);

    const handleOnclick = (e: any) => {
        e.preventDefault();
        navigate({
            pathname: modifyUrl,
            search: `?id=${proposition!.propositionId}`,
        });
        
    }
   
    if (loading) {
        return <LoaderModal hasMessage={false}/>
      } else if (loading === false && garanties.length === 0) {
        return <MgpMessage type="danger" message='Les garanties non trouvées' hasCloseBtn={true}/>
      }
    return (
        <div>
                <div className="flex-grid bg-blanc shadow-noir p-md mt-lg m-lg-desktop">
                    <div className="grid-flex wrapper-edition ">
                        <h2 className="card-title bleu mb-sm">
                         {(updatedProposition!.beneficiaries && updatedProposition!.beneficiaries.length > 0) ? "Mon choix de couverture pour tous les membres de ma famille" : "Mon choix de couverture"}
                        </h2>

                        {proposition && isPropositionInDraft(proposition) ? (  
                           <button className="clickableEl"  onClick={(e) => handleOnclick(e)}>
                                <span className="link-bleu edit">Modifier</span>
                                <i className="icon-crayon fushia fz-xs"></i>
                            </button> 
                            ) : (<div></div>)
                        }
                    </div>  

                <div className='grid-flex jc-start'>
                    <div className="p-xs card-selected box-guaranty m-y-md jc-center va-center"  style={{}}>
                        <p className="fw-medium fz-lg mt-sm ta-center">{guarantyCode?.titre}</p>
                        
                        <div className='m-x-lg m-y-sm ta-center'>
                            <span className="border-bleu light full mb-xs"></span>
                        </div>
                        
                        <p className='bleu fw-medium ta-center fz-md'>Votre cotisation*</p>
                        <p className='ta-center mb-xs fz-sm'>(hors cotisation obligatoire)</p>
                  
                    {(updatedProposition!.beneficiaries && updatedProposition!.beneficiaries.length > 0) ? 
                        <div>
                        <div className='ta-center'>
                            <p className='m-y-xs fz-lg fw-bold'>{modifyUrl === APP_URLS.guarantyPage ? optionPrice : offerPrice} / <span className='fz-sm fw-medium'>mois</span></p>
                        </div>
                        </div>
                        :
                        <div className='ta-center m-y-md'>
                            <p className=''><span className='fz-xs pr-xs'>Pour vous</span><span className='fz-lg fw-bold'>{modifyUrl === APP_URLS.guarantyPage ? optionPrice : offerPrice} / </span><span className='fz-sm fw-medium'>mois</span></p> 
                        </div>
                    }

                  <p className='fz-xs m-y-sm ta-center'>*Sur la base des informations déclarées</p>
                  
                </div>                                                                                                   
                    
                </div>
                </div>
            
        </div>
    )
}
